import { makeAutoObservable } from 'mobx';
import { id } from '@monorepo/tools/src/lib/types/primitives';

/**
 * The props the test crud page uses
 */
export interface IJob {
	id?: id;
	name?: string;
	taskClasses?: string;
	cronExpression?: string;
	isActive?: boolean;
	runOnInit?: boolean;
	maxRetries?: number;
	retryTimeout?: number;
	refreshRate?: number;
	jobIdentifier?: string;
	status?: string;
	retryAttempts?: number;
	errorMessage?: string;
	startTime?: Date;
	endTime?: Date;
	jobDuration?: number;
	nextRunTime?: Date;

	task_classes?: string;
	cron_expression?: string;
	is_active?: boolean;
	run_on_init?: boolean;
	max_retries?: number;
	retry_timeout?: number;
	refresh_rate?: number;
}

/**
 * The props to send to server
 */
export interface IJobCreateForm {
	id?: id;
	name?: string;
	task_classes?: string;
	cron_expression?: string;
	is_active?: boolean;
	run_on_init?: boolean;
	max_retries?: number;
	retry_timeout?: number;
	refresh_rate?: number;
}

export interface IJobEditForm {
	id?: id;
	name?: string;
	task_classes?: string;
	cron_expression?: string;
	is_active?: boolean;
	run_on_init?: boolean;
	max_retries?: number;
	retry_timeout?: number;
	refresh_rate?: number;
}

export class JobModel implements IJob {
	id?: id;
	name?: string;
	taskClasses?: string;
	cronExpression?: string;
	isActive?: boolean;
	runOnInit?: boolean;
	maxRetries?: number;
	retryTimeout?: number;
	refreshRate?: number;

	jobIdentifier?: string;
	status?: string;
	retryAttempts?: number;
	errorMessage?: string;
	startTime?: Date;
	endTime?: Date;
	jobDuration?: number;
	nextRunTime?: Date;

	constructor(props?: IJob) {
		this.id = props?.id;
		this.name = props?.name;
		this.taskClasses = props?.taskClasses ?? props?.task_classes;
		this.cronExpression = props?.cronExpression ?? props?.cron_expression;
		this.isActive = props?.isActive ?? props?.is_active;
		this.runOnInit = props?.runOnInit ?? props?.run_on_init;
		this.maxRetries = props?.maxRetries ?? props?.max_retries ?? 0;
		this.retryTimeout = props?.retryTimeout ?? props?.retry_timeout ?? 0;
		this.refreshRate = props?.refreshRate ?? props?.refresh_rate ?? 0;
		this.jobIdentifier = props?.jobIdentifier;
		this.status = props?.status;
		this.retryAttempts = props?.retryAttempts || 0;
		this.errorMessage = props?.errorMessage;
		this.startTime = props?.startTime;
		this.endTime = props?.endTime;
		this.jobDuration = props?.jobDuration || 0;
		this.nextRunTime = props?.nextRunTime;

		makeAutoObservable(this);
	}

	public getId(): id | undefined {
		return this.id;
	}

	public setId(id: id) {
		this.id = id;
	}

	public getName() {
		return this.name;
	}

	public setName(name: string) {
		this.name = name;
	}

	public getTaskClasses() {
		return this.taskClasses;
	}

	public setTaskClasses(taskClasses: string) {
		this.taskClasses = taskClasses;
	}

	public getCronExpression(): string | undefined {
		return this.cronExpression;
	}

	public setCronExpression(cronExpression: string): void {
		this.cronExpression = cronExpression;
	}

	public getIsActive(): boolean | undefined {
		return this.isActive;
	}

	public setIsActive(isActive: boolean): void {
		this.isActive = isActive;
	}

	public getRunOnInit(): boolean | undefined {
		return this.runOnInit;
	}

	public setRunOnInit(runOnInit: boolean): void {
		this.runOnInit = runOnInit;
	}

	public getMaxRetries(): number | undefined {
		return this.maxRetries;
	}

	public setMaxRetries(maxRetries: number): void {
		this.maxRetries = maxRetries;
	}

	public getRetryTimeout(): number | undefined {
		return this.retryTimeout;
	}

	public setRetryTimeout(retryTimeout: number): void {
		this.retryTimeout = retryTimeout;
	}

	public getRefreshRate(): number | undefined {
		return this.refreshRate;
	}

	public setRefreshRate(refreshRate: number): void {
		this.refreshRate = refreshRate;
	}
}
